import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorderStatics} from "../TheBorderStatics";
import {TheBorder} from "../TheBorder";
import {TheBorderGameAssets} from "../TheBorderGameAssets";
import {TimelineLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";

/**
 * Created by Jerker Nord on 2022-04-05.
 */

export class TheBorderXSplitView extends PIXI.Container implements StageLayer {

    constructor() {
        super();
        this.name = "TheBorderXSplitView";
        this.init();
    }

    public removeAll(): void {
        this.removeChildren();
    }

    public playXSplitOnOtherSymbols(pos: PIXI.Point, reel: number, isHalfSymbol: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            anim: PIXI.spine.Spine = new PIXI.spine.Spine(TheBorder.assetLoader.getSpineAsset(TheBorderGameAssets.X_SPLIT_SPINE));

        tl.add([
            () => {
                anim.position.set(pos.x + (TheBorderStatics.reelPositions[reel].x), pos.y - (isHalfSymbol ? 25 : 0));
            },
            new SpineTween(anim, 0, "winOther")
        ], 0);
        tl.add(() => {
            this.addChild(anim);
            TheBorder.soundPlayer.playXSplitSymbolCutSound(); //#210
        }, 0.01);

        return tl;
    }

    private init() {
        this.position = TheBorderStatics.MAIN_REELS_VIEW_POSITION;
    }
}